var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/verification/steps/sms-verification.tsx";
import React from 'react';
import { useIntl } from 'react-intl';
import OtpInput from 'react-otp-input';
import snackbar from 'soapbox/actions/snackbar';
import { confirmPhoneVerification, requestPhoneVerification } from 'soapbox/actions/verification';
import { Button, Form, FormGroup, PhoneInput, Text } from 'soapbox/components/ui';
import { useAppDispatch, useAppSelector } from 'soapbox/hooks';
const Statuses = {
  IDLE: 'IDLE',
  REQUESTED: 'REQUESTED',
  FAIL: 'FAIL'
};
const SmsVerification = () => {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector(state => state.verification.isLoading);
  const [phone, setPhone] = React.useState();
  const [status, setStatus] = React.useState(Statuses.IDLE);
  const [verificationCode, setVerificationCode] = React.useState('');
  const [requestedAnother, setAlreadyRequestedAnother] = React.useState(false);
  const isValid = !!phone;
  const onChange = React.useCallback(phone => {
    setPhone(phone);
  }, []);
  const handleSubmit = React.useCallback(event => {
    event.preventDefault();
    if (!isValid) {
      setStatus(Statuses.IDLE);
      dispatch(snackbar.error(intl.formatMessage({
        id: 'sms_verification.invalid',
        defaultMessage: 'Please enter a valid phone number.'
      })));
      return;
    }
    dispatch(requestPhoneVerification(phone)).then(() => {
      dispatch(snackbar.success(intl.formatMessage({
        id: 'sms_verification.success',
        defaultMessage: 'A verification code has been sent to your phone number.'
      })));
      setStatus(Statuses.REQUESTED);
    }).catch(error => {
      const message = error.response?.data?.message || intl.formatMessage({
        id: 'sms_verification.fail',
        defaultMessage: 'Failed to send SMS message to your phone number.'
      });
      dispatch(snackbar.error(message));
      setStatus(Statuses.FAIL);
    });
  }, [phone, isValid]);
  const resendVerificationCode = React.useCallback(event => {
    setAlreadyRequestedAnother(true);
    handleSubmit(event);
  }, [isValid]);
  const submitVerification = () => {
    // TODO: handle proper validation from Pepe -- expired vs invalid
    dispatch(confirmPhoneVerification(verificationCode)).catch(() => dispatch(snackbar.error(intl.formatMessage({
      id: 'sms_verification.invalid',
      defaultMessage: 'Your SMS token has expired.'
    }))));
  };
  React.useEffect(() => {
    if (verificationCode.length === 6) {
      submitVerification();
    }
  }, [verificationCode]);
  if (status === Statuses.REQUESTED) {
    return /*#__PURE__*/React.createElement("div", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 97,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "pb-4 sm:pb-10 mb-4 border-b border-gray-200 dark:border-gray-600 border-solid -mx-4 sm:-mx-10",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 98,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement("h1", {
      className: "text-center font-bold text-2xl",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 99,
        columnNumber: 11
      }
    }, intl.formatMessage({
      id: 'sms_verification.sent.header',
      defaultMessage: 'Verification code'
    }))), /*#__PURE__*/React.createElement("div", {
      className: "sm:pt-10 sm:w-2/3 md:w-1/2 mx-auto space-y-4",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 104,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(Text, {
      theme: "muted",
      size: "sm",
      align: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 105,
        columnNumber: 11
      }
    }, "We sent you a 6-digit code via SMS. Enter it below."), /*#__PURE__*/React.createElement(OtpInput, {
      value: verificationCode,
      onChange: setVerificationCode,
      numInputs: 6,
      isInputNum: true,
      shouldAutoFocus: true,
      isDisabled: isLoading,
      containerStyle: "flex justify-center mt-2 space-x-4",
      inputStyle: "w-10i border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 109,
        columnNumber: 11
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "text-center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 120,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      type: "button",
      theme: "ghost",
      onClick: resendVerificationCode,
      disabled: requestedAnother,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 121,
        columnNumber: 13
      }
    }, "Resend verification code?"))));
  }
  return /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 137,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "pb-4 sm:pb-10 mb-4 border-b border-gray-200 dark:border-gray-600 border-solid -mx-4 sm:-mx-10",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 138,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-center font-bold text-2xl",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 139,
      columnNumber: 9
    }
  }, intl.formatMessage({
    id: 'sms_verification.header',
    defaultMessage: 'Enter your phone number'
  }))), /*#__PURE__*/React.createElement("div", {
    className: "sm:pt-10 sm:w-2/3 md:w-1/2 mx-auto",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 142,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: handleSubmit,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 143,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(FormGroup, {
    labelText: "Phone Number",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 144,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(PhoneInput, {
    value: phone,
    onChange: onChange,
    required: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 145,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 152,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Button, {
    block: true,
    theme: "primary",
    type: "submit",
    disabled: isLoading || !isValid,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 153,
      columnNumber: 13
    }
  }, "Next")))));
};
export { SmsVerification as default };